/* EkDoTee Premium: quiet scroll reveals. No layout changes, safe to fail. */
(function () {
  try {
    if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var sel = '.section-head, .statement__text, .eyebrow, .split__body, .spotlight, .review, .footer__lead, .newsletter h2, .page-head, .collection-hero h1, .card';
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    function mark(root) {
      (root || document).querySelectorAll(sel).forEach(function (el) {
        if (el.hasAttribute('data-prem') || el.closest('.hero')) return;
        var i = 0, p = el.parentElement;
        if (el.classList.contains('card') && p) { i = Array.prototype.indexOf.call(p.parentElement ? p.parentElement.children : [], p) % 4; }
        el.style.setProperty('--prem-delay', (i * 70) + 'ms');
        el.setAttribute('data-prem', '');
        var r = el.getBoundingClientRect();
        if (r.top < window.innerHeight * 0.92 && r.bottom > 0) { requestAnimationFrame(function () { el.classList.add('is-in'); }); }
        else io.observe(el);
      });
    }
    mark();
    new MutationObserver(function (ms) { ms.forEach(function (m) { m.addedNodes.forEach(function (n) { if (n.nodeType === 1) mark(n.parentNode || document); }); }); }).observe(document.body, { childList: true, subtree: true });
  } catch (e) {}
})();
